<div class="headerPart d-flex justify-content-center align-items-center bg-white p-2 mb-1">

    <span>مدیریت درخواست های سفر</span>
    
</div>

<div class="d-flex p-2 text-white bg-dark rounded">
    <ul class="nav nav-pills  mb-auto" id="selectTab">

        <li>
            <span class="nav-link text-white pointer" (click)="setActiveTab('confirm')" id="confirm">
                تایید شده
            </span>
        </li>
        <li>
            <span class="nav-link text-white pointer" (click)="setActiveTab('DriverConfirm')" id="DriverConfirm">
                منتظر تایید راننده
            </span>
        </li>
        <li>
            <span class="nav-link text-white pointer" (click)="setActiveTab('ongoing')" id="ongoing">
                در حال اجرا
            </span>
        </li>
        <li>
            <span class="nav-link text-white pointer" (click)="setActiveTab('aborted')" id="aborted">
                لغو شده
            </span>
        </li>
        <li>
            <span class="nav-link text-white pointer" (click)="setActiveTab('planned')" id="planned">
                برنامه ریزی شده
            </span>
        </li>
    </ul>
</div>

<!-- جستجوی مدیریت درخواست های سفر -->

<ng-container *ngIf="trips?.length > 0 || list_Search?.length > 0">

    <div class="row gx-2 gy-2  my-2">

        <div [ngClass]="menuType != 'ongoing' ? 'col-7' : 'col-12' ">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید..." (keyup)="filterResult($event.target)">

        </div>

        <ng-container *ngIf="menuType == 'confirm'">

            <div class="col-auto" (click)="group_Assignment()">

                <button class="btn btn-secondary" style="font-size: 14px;"> 

                    اختصاص گروهی
                    
                </button>

            </div>

            <div class="col-auto" (click)="openClustering()">

                <button class="btn btn-secondary" style="font-size: 14px;"> 

                    خوشه بندی سفر
                    
                </button>

            </div>

        </ng-container>

        <ng-container *ngIf="menuType != 'ongoing'">

            <div class="col-auto">

                <button class="btn btn-primary" style="font-size: 14px;" (click)="selectAllCheckBox()"> انتخاب همه </button>

            </div>

            <div class="col-auto">

                <button class="btn btn-success" style="font-size: 14px;" (click)="archiveTrip()"> بایگانی  </button>

            </div>

        </ng-container>

    </div>


</ng-container>

<ng-container *ngIf="trips?.length == 0">

    <div class="d-flex flex-column justify-content-center align-items-center mt-4">

        <img src="../../../assets/Img/nothingToShow.gif" width="450px" alt="loading">

        <span class="fw-bold mt-2 f18">داده ای برای نمایش وجود ندارد!</span>

    </div>

</ng-container>

<div class="col-12 d-flex justify-content-center table-responsive dirI overflow-auto" style="max-height:85vh;">

    <ng-container *ngIf="isLoading">

        <div class="d-flex justify-content-center align-items-center h-100">

            <img src="../../../assets/Img/loading_safar.gif" alt="loading">

        </div>

    </ng-container>

    <!-- تایید شده -->

    <ng-container *ngIf="menuType == 'confirm' && trips?.length > 0">

        <div class="section">
             
            <table class="table table-striped bg-white mt-1 dirI " id="excel-car-list" >

                <thead>

                    <tr class="text-center">

                        <th scope="col"># </th>

                        <th scope="col pointer" (click)="selectAllCheckBox()">انتخاب</th>

                        <th scope="col">عملیات</th>

                        <th scope="col" *ngIf="bCluster"> خوشه </th>

                        <th scope="col">کد</th>

                        <th scope="col">تاریخ ثبت</th>

                        <th scope="col">ساعت ثبت</th>

                        <th scope="col">متقاضی</th>

                        <th scope="col"> نوع سفر </th>

                        <th scope="col">تاریخ سفر</th>

                        <th scope="col" class="pointer" (click)="sortColumn(1)">

                            ساعت سفر

                            <i class="fa fa-sort" aria-hidden="true"></i>

                        </th>

                        <th scope="col">کاربری خودرو</th>

                        <th scope="col">دلیل سفر</th>

                        <th scope="col " class="pointer" (click)="sortColumn(2)"> 

                            مبدأ

                            <i class="fa fa-sort" aria-hidden="true"></i>
                            
                        </th>
                        
                        <th scope="col" class="pointer" (click)="sortColumn(3)"> 

                            مقصد

                            <i class="fa fa-sort" aria-hidden="true"></i>
                            
                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="f14 text-center" 

                        [ngStyle]="{ 'background-color' : bCluster ? getRowColor(item.ClusterId) : item.tiTripImportance == 1 ? '#fdba74' : item.tiTripImportance == 2 ? '#fca5a5' : '' }"
                    
                        *ngFor="let item of trips;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <td>
                            <input type="checkbox" class="pointer" 
                            
                                (change)="setCheckBox($event.target.checked,item)"
                            
                                [checked]="isSelected(item.iOfficialTrip)">
                        
                        </td>

                        <td class="">

                            <div class="pb-3 d-flex gap-2">

                                <i class="fa fa-info-circle fa-lg text-primary pointer" (click)="showDetailsModal(item)"></i>

                                <i (click)="newMapShowTripSourceAndDest(item)" title="نمایش مبدأ و مقصد" class="fa fa-map-pin fa-lg text-info pointer"></i>
    
                                <i class="fa fa-car text-primary pointer" title="اختصاص به خوردو در حال سرویس" (click)="getDriversList(item,true)" aria-hidden="true"></i>

                                <i class="fa fa-car text-success pointer" title="اختصاص خوردو" (click)="getDriversList(item)" aria-hidden="true"></i>
    
                                <i class="fa fa-edit fa-lg text-secondary pointer" (click)="showDetailsModal(item,true)"></i>

                            </div>

                        </td>

                        <th *ngIf="bCluster" class="text-dark">{{item.ClusterId|faNum}}</th>
                        
                        <th class="text-dark">{{item.iOfficialTrip|faNum}}</th>

                        <th class="text-dark">{{item.strRequestDate |faNum}}</th>

                        <th class="text-dark">{{item.strRequestTime | faNum}}</th>

                        <th class="text-dark">{{item.strApplicantName + ' ' + item.strApplicantFamily }}</th>

                        <!-- <th class="text-dark">{{item.strUserManager_Chart_strComment | faNum}}</th> -->

                        <th class="text-dark">{{item.bMission? 'مأموریتی': item.bExclusive? 'در اختیار': item.bHaveReturn? 'دوطرفه': 'یک طرفه'}}</th>

                        <th class="text-dark">{{item.strTripDate | faNum}}</th>

                        <th class="text-dark">{{item.strTripTime | faNum}}</th>

                        <th class="text-dark">{{item.strTripMobileType_strComment}}</th>

                        <th class="text-dark">{{item.strTripReason_strComment}}</th>

                        <!-- <th class="text-dark">{{item.strTripImportance_strComment}}</th> -->
                        
                        <th style="max-width: 130px;text-wrap: wrap;" class="text-dark">

                            {{item.strSourceAddress}}

                        </th>

                        <th style="max-width: 130px;text-wrap: wrap;" class="text-dark">

                            {{item.strDestinationAddress}}

                        </th>

                    </tr>

                </tbody>

            </table>

        </div>

    </ng-container>

    <!-- منتظر تایید راننده -->

    <ng-container *ngIf="menuType == 'DriverConfirm' && trips?.length > 0">

        <div class="section">
             
            <table class="table table-striped bg-white mt-1 dirI " id="excel-car-list" >

                <thead>

                    <tr class="text-center">

                        <th scope="col"># </th>

                        <th scope="col pointer" (click)="selectAllCheckBox()">انتخاب</th>

                        <th scope="col">عملیات</th>

                        <th scope="col">راننده</th>

                        <th scope="col">موبایل راننده</th>

                        <th scope="col">کاربری خودرو</th>

                        <th scope="col">تاریخ سفر</th>

                        <th scope="col">ساعت سفر</th>

                        <th scope="col">متقاضی</th>

                        <th scope="col">جایگاه سازمانی</th>

                        <th scope="col">نوع سفر</th>

                        <th scope="col">اهمیت سفر</th>

                        <th scope="col">مبدا سفر</th>

                        <th scope="col">مقصد سفر</th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="f14" *ngFor="let item of trips;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum}}</th>

                        <td>
                            <input type="checkbox" class="pointer" 
                            
                                (change)="setCheckBox($event.target.checked,item)"
                            
                                [checked]="isSelected(item.iOfficialTrip)">
                        
                        </td>

                        <th class="d-flex gap-2 pb-3">

                            <i class="fa fa-info-circle fa-lg text-primary pointer" (click)="showDetailsModal(item)"></i>

                            <i class="fa fa-paper-plane fa-lg text-dark pointer" title="ارسال پیامک به راننده" data-bs-toggle="modal" data-bs-target="#sendSmsModal" (click)="currentRecord = item"></i>

                            <i class="fa fa-car text-success pointer" title="اختصاص خوردو" (click)="getDriversList(item)" aria-hidden="true"></i>

                            <i (click)="newMapShowTripSourceAndDest(item)" class="fa fa-map-pin fa-lg text-info pointer"></i>

                        </th>

                        <th class="text-dark">{{item.strFullName}}</th>

                        <th class="text-dark">{{item.strMobile | faNum}}</th>

                        <th class="text-dark">{{item.strMobileType_strComment}}</th>

                        <th class="text-dark">{{item.strTripDate | faNum}}</th>

                        <th class="text-dark">{{item.strTripTime | faNum}}</th>

                        <th class="text-dark">{{item.strApplicantName + ' ' + item.strApplicantFamily }}</th>

                        <th class="text-dark">{{item.strUserManager_Chart_strComment | faNum}}</th>

                        <th class="text-dark">{{item.bMission? 'مأموریتی': item.bExclusive? 'در اختیار': item.bHaveReturn?  'دوطرفه': 'یک طرفه'}}</th>

                        <th class="text-dark">{{item.strTripReason_strComment}}</th>

                        <th class="text-dark">{{item.strSourceAddress}}</th>

                        <th class="text-dark">{{item.strDestinationAddress}}</th>

                    </tr>

                </tbody>

            </table>

        </div>

    </ng-container>

    <!-- در حال اجرا -->

    <ng-container *ngIf="menuType == 'ongoing' && trips?.length > 0">

        <!-- <div class="section"> -->
             
            <table class="table table-striped bg-white mt-1 dirI " id="excel-car-list" >

                <thead>

                    <tr class="text-center">

                        <th scope="col"># </th>

                        <th scope="col">عملیات</th>

                        <th scope="col">کد سفر </th>

                        <th scope="col">راننده</th>

                        <th scope="col">موبایل راننده</th>

                        <th scope="col">متقاضی</th>

                        <th scope="col">مبدأ مقصد</th>

                        <th scope="col">مقصد</th>

                        <th scope="col">وضعیت سفر </th>
                    </tr>

                </thead>

                <tbody>
                    <tr class="f14 text-center" *ngFor="let item of trips;let i=index">

                        <th class="text-dark">{{i+1 | faNum}}</th>

                        <th class="d-flex justify-content-center gap-2 pb-3">

                            <i class="fa fa-info-circle fa-lg text-primary pointer" (click)="showDetailsModal(item)"></i>

                            <i (click)="newMapShowTripSourceAndDest(item)" class="fa fa-map-pin fa-lg text-info pointer"></i>

                            <i  (click)="setTripRejection('',item)" class="fa fa-times-circle-o fa-lg text-danger pointer" title="لغو"></i>

                            <i  (click)="show_DriverLocation(item)" class="fa fa-location-arrow fa-lg text-success pointer" title="موقعیت راننده"></i>

                            <i class="fa fa-edit fa-lg text-secondary pointer" (click)="showDetailsModal(item,true)"></i>

                        </th>

                        <th class="text-dark">{{item.iOfficialTrip|faNum}}</th>

                        <th class="text-dark">{{item.strFullName}}</th>

                        <th class="text-dark">{{item.strMobile | faNum}}</th>

                        <th class="text-dark">{{item.strApplicantName}} {{item.strApplicantFamily}}</th>

                        <th class="text-dark">{{item.strSourceAddress}}</th>

                        <th class="text-dark">{{item.strDestinationAddress}}</th>

                        <th class="text-dark">{{item.strTripStatus_strComment}}</th>

                    </tr>
                </tbody>

            </table>

        <!-- </div> -->

    </ng-container>

    <!-- لغو شده -->

    <ng-container *ngIf="menuType == 'aborted' && trips?.length > 0">

        <div class="section">
             
            <table class="table table-striped bg-white mt-1 dirI " id="excel-car-list" >

                <thead>

                    <tr class="text-center">

                        <th scope="col"># </th>

                        <th scope="col pointer" (click)="selectAllCheckBox()">انتخاب</th>

                        <th scope="col ">عملیات</th>

                        <th scope="col">کد سفر </th>

                        <th scope="col">نام متقاضی</th>

                        <th scope="col">جایگاه سازمانی متقاضی</th>

                        <th scope="col">تاریخ درخواست</th>

                        <th scope="col">ساعت درخواست</th>

                        <th scope="col">نوع سفر</th>

                        <th scope="col">دلیل سفر</th>

                        <th scope="col">اهمیت سفر</th>

                        <th scope="col">آدرس مقصد</th>

                    </tr>

                </thead>

                <tbody>
                    <tr class="f14 text-center" *ngFor="let item of trips;let i=index">

                        <th class="text-dark">{{i+1 | faNum}}</th>

                        <td>
                            <input type="checkbox" class="pointer" 
                            
                                (change)="setCheckBox($event.target.checked,item)"
                            
                                [checked]="isSelected(item.iOfficialTrip)">
                        
                        </td>

                        <th class="d-flex gap-2 pb-3">
                            <i class="fa fa-info-circle fa-lg text-primary pointer" (click)="showDetailsModal(item)"></i>
                            <i (click)="newMapShowTripSourceAndDest(item)"
                                class="fa fa-map-pin fa-lg text-info pointer"></i>
                        </th>
                        
                        <th class="text-dark">{{item.iOfficialTrip|faNum}}</th>
                        <th class="text-dark">{{item.strApplicantName}} {{item.strApplicantFamily}}</th>
                        <th class="text-dark">{{item.strUserManager_Chart_strComment}}</th>
                        <th class="text-dark">{{item.strTripDate | faNum}}</th>
                        <th class="text-dark">{{item.strTripTime | faNum}}</th>
                        <th class="text-dark">{{item.bMission? 'مأموریتی': item.bExclusive? 'در اختیار': item.bHaveReturn?
                            'دوطرفه': 'یک طرفه'}}</th>
                        <th class="text-dark">{{item.strTripReason_strComment}}</th>
                        <th class="text-dark">{{item.strTripImportance_strComment}}</th>
                        <th class="text-dark">{{item.strDestinationAddress}}</th>
                    </tr>
                </tbody>

            </table>

        </div>

    </ng-container>

    <!-- برنامه ریزی شده -->

    <ng-container *ngIf="menuType == 'planned' && trips?.length > 0">
        <table class="table table-striped bg-white mt-1 dirI">
            <thead>
                <tr class="text-center">
                    <th scope="col"># </th>
                    <th scope="col pointer" (click)="selectAllCheckBox()">انتخاب</th>
                    <th scope="col">عملیات</th>
                    <th scope="col">کد سفر </th>
                    <th scope="col">نام متقاضی</th>
                    <th scope="col">جایگاه سازمانی متقاضی</th>
                    <th scope="col">تاریخ سفر</th>
                    <th scope="col">ساعت سفر</th>
                    <th scope="col">نوع سفر</th>
                    <th scope="col">دلیل سفر</th>
                    <th scope="col">اهمیت سفر</th>
                    <th scope="col">آدرس مقصد</th>
                </tr>
            </thead>
            <tbody>
                <tr class="f14 text-center" *ngFor="let item of trips;let i=index">

                    <th class="text-dark">{{i+1 | faNum}}</th>

                    <td>

                        <input type="checkbox" class="pointer" 
                        
                            (change)="setCheckBox($event.target.checked,item)"
                        
                            [checked]="isSelected(item.iOfficialTrip)">
                    
                    </td>

                    <th class="d-flex gap-2 pb-3">

                        <i class="fa fa-info-circle fa-lg text-primary pointer" (click)="showDetailsModal(item)"></i>

                        <i (click)="newMapShowTripSourceAndDest(item)" class="fa fa-map-pin fa-lg text-info pointer"></i>

                        <i class="fa fa-edit fa-lg text-secondary pointer" (click)="showDetailsModal(item,true)"></i>

                    </th>
                    
                    <th class="text-dark">{{item.iOfficialTrip|faNum}}</th>
                    <th class="text-dark">{{item.strApplicantName}} {{item.strApplicantFamily}}</th>
                    <th class="text-dark">{{item.strUserManager_Chart_strComment}}</th>
                    <th class="text-dark">{{item.strTripDate | faNum}}</th>
                    <th class="text-dark">{{item.strTripTime | faNum}}</th>
                    <th class="text-dark">{{item.bMission? 'مأموریتی': item.bExclusive? 'در اختیار': item.bHaveReturn? 'دوطرفه': 'یک طرفه'}}</th>
                    <th class="text-dark">{{item.strTripReason_strComment}}</th>
                    <th class="text-dark">{{item.strTripImportance_strComment}}</th>
                    <th class="text-dark">{{item.strDestinationAddress}}</th>
                </tr>
            </tbody>
        </table>
    </ng-container>

</div>

<!-- Send SMS to Driver Modal -->

<div class="modal fade" id="sendSmsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">اختصاص خودرو</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <textarea class="form-control" placeholder="متن پیامک ارسالی را وارد کنید..." id="smstextHolder"
                        rows="3" #smsText></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="sendSmsToDriver()">ارسال
                    پیامک</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
            </div>
        </div>
    </div>
</div>

<!-- Assign Driver Modal -->

<div class="modal fade" id="DriverAssignModal" tabindex="-1" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel">اختصاص خودرو</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <ng-container *ngIf="isLoading">

                    <div class="d-flex justify-content-center align-items-center h-100">

                        <img src="../../../assets/Img/loading_safar.gif" alt="loading">

                    </div>

                </ng-container>

                <ng-container *ngIf="!isLoading">

                    <div class="d-flex align-items-center mb-4">

                        <input name="searchIn" type="text" class="form-control" placeholder="جستجو..." (keyup)="filter_DriverResult($event.target)">

                    </div>

                    <table class="border border-1 table table-striped bg-white mt-1 dirI">

                        <thead>

                            <tr class="text-center">

                                <th scope="col"># </th>

                                <th scope="col"> عملیات </th>

                                <th scope="col">کاربری</th>

                                <th scope="col">خودرو</th>

                                <th scope="col">نام راننده</th>

                                <th scope="col">سرویس</th>

                                <th scope="col">فاصله تا مبداء</th>

                                <th scope="col">حوزه خدمت</th>

                                <th scope="col">آخرین سابقه</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="f14 pointer hoverItem text-center" 
                            
                                [ngStyle]="{'background-color': item.bHastrafficLoc ? '#6ee7b7' : item.bHasEvenoddb ? '##7dd3fc' : ''}"
                            
                                (click)="selectDriver(item)"

                                *ngFor="let item of drivers; let i=index">

                                <!-- خودرویی که طرح ترافیک دارد سبز رنگ و طرح آلودگی آبی -->

                                <th class="text-dark">{{ i + 1 | faNum}}</th>

                                <th class="text-dark"> 

                                    <i class="fa fa-list-alt fa-lg" 
                                    
                                        title="برنامه سفرهای راننده " 
                                        
                                        (click)="get_driverPlan(item,$event)">
                                    
                                    </i>
                                    
                                </th>

                                <th class="text-dark">{{item.strMobileType_strComment}}</th>

                                <th class="text-dark">{{item.strGPSType_strComment | faNum}}</th>

                                <th class="text-dark">{{item.strFullName}}</th>

                                <th class="text-dark">{{item.iTrip | faNum}}</th>

                                <th class="text-dark"> {{item.DistanceKM + ' کیلومتر ' | faNum }}</th>

                                <th class="text-dark">{{item.strMobileDomain_strComment}}</th>

                                <th class="text-dark">{{item.strDate | faNum}} - {{item.strTime | faNum}}</th>
                            </tr>

                        </tbody>

                    </table>

                </ng-container>

                <div class="modal-footer">

                    <!-- <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="newMapShowTripSourceAndDest(currentRecord)">تحلیل فاصله خودرو ها با مبدا سفر</button> -->

                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- Map modal -->

<div class="modal fade" id="maplat1" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content p-1">
            <div class="modal-header dirI" style="height: 20px;">
                <h5 class="modal-title">مبدأ و مقصد</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div id="map" class="position-sticky w-100 " style="height: 650px;">
                <div [formGroup]="path"
                    class="d-flex justify-content-around flex-wrap position-absolute dirI bg-th-yellow w-100 p-1 border-bottom border-info"
                    style="z-index: 1000; margin-bottom: 10px;">
                    <div class="mx-1">
                        <span>مسافت تقریبی: <strong>{{path.controls['distance'].value}}</strong> کیلومتر</span>
                    </div>
                    <div class="mx-1">
                        <span>زمان تقریبی سفر: <strong>{{path.controls['duration'].value}}</strong> دقیقه</span>
                    </div>
                </div>
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Trip Detail Modal -->

<div class="modal fade" id="tripModal" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ isEditComp ? '' : 'اطلاعات سفر'}} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="isEditComp ? closeEditTrip() : ''">


                </button>
                
            </div>

            <!-- ویرایش اطلاعات سفر -->

            <ng-container *ngIf="isEditComp;else detailModal">

                <app-trip-cartable [tripObj]="currentRecord" (tripModal_Close)="closeEditTrip($event, true)"> </app-trip-cartable>

            </ng-container>

            <!-- مشاهده اطلاعات سفر -->

            <ng-template #detailModal>

                <div class="modal-body">

                    <div class="container-fluid row gx-2 gy-2 p-2 rounded" style="border: 1px solid rgb(204, 204, 204);">
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> کد رهگیری</label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.iOfficialTrip | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> نام و نام خانوادگی </label>
    
                            <input class="form-control text-center p-2" [value]="currentRecord?.strApplicantName + ' '+ currentRecord?.strApplicantFamily" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> شماره موبایل </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strApplicantMobile | faNum " disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> دلیل سفر </label>
    
                            <input class="form-control text-center p-2" [value]="currentRecord?.strTripReason_strComment" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> کاربری متحرک </label>
    
                            <input class="form-control text-center p-2" [value]="currentRecord?.strTripMobileType_strComment" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> تاریخ درخواست </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strRequestDate | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> اهمیت سفر </label>
    
                            <input class="form-control p-2 text-center"  [value]="currentRecord?.strTripImportance_strComment | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> جایگاه سازمانی </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strChartName | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> ساعت درخواست </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strRequestTime.trim() | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> نوع سفر </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.bMission? 'مأموریتی': currentRecord?.bExclusive? 'در اختیار': currentRecord?.bHaveReturn? 'دو طرفه': 'یک طرفه'" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> تاریخ سفر </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strTripDate | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> ساعت  سفر </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strTripTime | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> تعداد سفرهای امروز جایگاه سازمانی </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.tiAppUsage + ' مورد ' | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-3 p-2">
            
                            <label class="mb-2 text-muted"> حوزه خدمت متقاضی  </label>
    
                            <input class="form-control p-2 text-center" [value]="currentRecord?.strMobileDomain_strComment" disabled>
    
                        </div>
    
                        <div class="col-12 border border-1 my-3"></div>
    
                        <div class="position-relative col-12 col-md-6 p-2">
            
                            <label class="mb-2 text-muted"> همراهان </label>
    
                            <input class="form-control text-center p-2" [value]="currentRecord?.strPassengersName" disabled>
    
                        </div>
    
                        <div class="position-relative col-12 col-md-6 p-2">
            
                            <label class="mb-2 text-muted"> موبایل همراهان </label>
    
                            <input class="form-control p-2 text-end" 
                            
                                [value]="currentRecord?.strPassengersMobile | faNum" disabled>
    
                        </div>
    
                        <div class="position-relative col-12  p-2">
            
                            <label class="mb-2 text-muted"> مبدأ </label>
    
                            <input class="form-control  p-2" [value]="currentRecord?.strSourceAddress" disabled>
    
                        </div>
    
                        <div class="position-relative col-12  p-2">
            
                            <label class="mb-2 text-muted"> مقصد </label>
    
                            <input class="form-control p-2" [value]="currentRecord?.strDestinationAddress" disabled>
    
                        </div>
    
                        <div class="position-relative col-12  p-2">
            
                            <label class="mb-2 text-muted"> توضیحات </label>
    
                            <input class="form-control text-center p-2" [value]="currentRecord?.strComment" disabled>
    
                        </div>
    
                    </div>
    
                </div>
    
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="newMapShowTripSourceAndDest(currentRecord)">مسیر سفر</button>
                    <button type="button" *ngIf="menuType != 'ongoing'" class="btn btn-success"
                        (click)="ArchiveTrip('DetailModal')">بایگانی</button>
                    <button type="button" class="btn btn-danger" *ngIf="menuType != 'planned'"
                        (click)="setTripRejection('DetailModal')">لغو</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                </div>

            </ng-template>

        </div>

    </div>

</div>

<!--  -->

<div class="modal fade" id="driver_Plan" tabindex="-1" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> برنامه سفرهای راننده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="height: 50vh;overflow: auto;">

                <table class="border border-1 table table-striped bg-white mt-1 dirI">

                    <thead>

                        <tr class="text-center">

                            <th scope="col"> # </th>

                            <th scope="col"> ساعت </th>

                            <th scope="col">مسافر</th>

                            <th scope="col">مبدا</th>

                            <th scope="col">مقصد</th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="f14 pointer hoverItem text-center" *ngFor="let item of lst_DriverPlan; let i=index">

                            <th class="text-dark">{{ i + 1 | faNum}}</th>

                            <th class="text-dark">{{ item.strTripTime | faNum}}</th>

                            <th class="text-dark">{{ item.strPassengersName | faNum}}</th>

                            <th class="text-dark">{{ item.strSourceAddress | faNum}}</th>

                            <th class="text-dark">{{ item.strDestinationAddress || 'نامشخص' | faNum}}</th>

                        </tr>

                    </tbody>

                </table>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال خوشه بندی -->

<div class="modal fade" id="Modal_Clustering" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> خوشه بندی هوشمند </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Cluster" dir="rtl" class="row p-2 gx-2 gy-2">

                    <!-- تعداد پرسنل در خودرو -->
    
                    <div class="col-12">
    
                        <label> تعداد پرسنل در خودرو </label>
    
                        <input formControlName="tiPassengers" class="form-control text-end">
    
                    </div>

                    <!-- حداکثر فاصله سفرها از هم -->
    
                    <div class="col-12">
    
                        <label> حداکثر فاصله سفرها از هم(کیلومتر) </label>
    
                        <input formControlName="fMaxDistanceInKm" class="form-control text-end">
    
                    </div>

                    <!-- فاصله زمانی تقاضای سرویس  -->
    
                    <div class="col-12">
    
                        <label> فاصله زمانی تقاضای سرویس (دقیقه) </label>
    
                        <input formControlName="iMinute" class="form-control text-end">
    
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="search_Cluster()">

                    &nbsp; جستجو &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>